import React, { memo } from 'react';
import InputText from 'app/components/common/InputText';
import { InputText as InputTextV2, Button } from '@encarpkg/design';
import MyArrowButton from 'app/components/my/info/MyArrowButton';
import { Enlog } from '@encarpkg/shared';
import classNames from 'classnames/bind';
import styles from './InputAddress.module.scss';

const cx = classNames.bind(styles);

const InputAddress = (props) => {
	const {
		label = '',
		hideLabel = false,
		postCdId,
		postCdName,
		postCdValue,
		addressId,
		addressName,
		addressValue,
		detailId,
		detailName,
		detailValue = '',
		onChange = () => console.warn('onChange is not defined'),
		onClick = () => console.warn('onClick is not defined'),
		validation = false,
		required = false,
		onBlur = () => console.warn('onClick is not defined'),
		readOnly = false,
		addressDetailRef = null,
		noDetail = false,
		validationText = '주소를 입력해주세요.',
		inputDesign = 'input',
		style = { marginTop: '30px' },
		maxLength = undefined,
		isV2 = false,
	} = props;
	const dataSet = Enlog().propsDataset(props);
	const btnDom = !postCdValue ? (
		<Button.V2
			domType="button"
			color="primarylight"
			size={30}
			className={cx('btn')}
			onClick={onClick}
		>
			우편번호찾기
		</Button.V2>
	) : null;

	if (isV2) {
		return (
			<div className={cx('wrap_addr')}>
				<InputTextV2
					inputDesign={inputDesign}
					label={label}
					type="number"
					id={postCdId}
					name={postCdName}
					value={postCdValue}
					placeholder="우편번호"
					onChange={onChange}
					validation={validation}
					useLabel={!hideLabel}
					readOnly
					required={required}
					labelStyle={{ marginTop: '26px' }}
					style={!postCdValue ? { backgroundColor: '#FFF' } : null}
					addDom={btnDom}
					addTopRightDom={postCdValue && <MyArrowButton onClick={onClick}>우편번호 찾기</MyArrowButton>}
				/>

				<InputTextV2
					inputDesign={inputDesign}
					type="text"
					id={addressId}
					name={addressName}
					value={addressValue}
					placeholder="주소"
					onChange={onChange}
					validation={validation}
					readOnly
					style={{ marginTop: '10px' }}
				/>

				{!noDetail && (
					<InputTextV2
						inputDesign={inputDesign}
						type="text"
						id={detailId}
						name={detailName}
						value={detailValue}
						placeholder="상세주소 입력"
						onChange={onChange}
						onBlur={onBlur}
						validation={validation}
						validationText={validationText}
						readOnly={readOnly}
						ref={addressDetailRef}
						style={{ marginTop: '10px' }}
						maxLength={maxLength}
					/>
				)}
			</div>
		);
	}

	return (
		<>
			<InputText
				inputDesign={inputDesign}
				label={label}
				type="number"
				id={postCdId}
				name={postCdName}
				value={postCdValue}
				placeholder="우편번호"
				onChange={onChange}
				validation={validation}
				useLabel={!hideLabel}
				useBtn={!readOnly}
				btnName="우편번호찾기"
				onClick={onClick}
				readOnly
				required={required}
				style={style}
			/>

			<InputText
				inputDesign={inputDesign}
				type="text"
				id={addressId}
				name={addressName}
				value={addressValue}
				placeholder="주소"
				onChange={onChange}
				validation={validation}
				readOnly
				style={inputDesign === 'square' ? { marginTop: '10px' } : { marginTop: '30px' }}
			/>

			{!noDetail && (
				<InputText
					inputDesign={inputDesign}
					type="text"
					id={detailId}
					name={detailName}
					value={detailValue}
					placeholder="상세주소 입력"
					onChange={onChange}
					onBlur={onBlur}
					validation={validation}
					validationText={validationText}
					readOnly={readOnly}
					ref={addressDetailRef}
					style={inputDesign === 'square' ? { marginTop: '10px' } : { marginTop: '30px' }}
					maxLength={maxLength}
					{...dataSet}
				/>
			)}
		</>
	);
};

export default memo(InputAddress);
